import './EmergencyNotification.scss';
import $ from "jquery";

$(document).ready(function () {
    var emergencyNotification = $(".urgent-message");
    if (emergencyNotification && emergencyNotification.length > 0) {
        $('#main-header').css("top", "60px");

        if ($(window).width() >= 767) {
            if (window.location.href.indexOf("/lp/") > -1) {
                $('.body-content').css("padding-top", "290px");
            } else {
                $('.body-content').css("padding-top", "240px");
            }
        } else {
            if (window.location.href.indexOf("/lp/") > -1) {
                $('.body-content').css("padding-top", "240px");
            } else {
                $('.body-content').css("padding-top", "114px");
                $('.body-content').css("padding-top", "130px");
            }
        }
    }
});


// WEBPACK FOOTER //
// ./Src/Shared/EmergencyNotification/EmergencyNotification.js